import {
	DEFAULT_QUESTIONNAIRE_TEMPLATE_ID,
	DEFAULT_QUESTIONNAIRE_TEMPLATE_VERSION,
	QUESTIONNAIRE_GENDERS,
	QUESTIONNAIRE_PHASES,
	QUESTIONNAIRE_QUESTION_TYPES,
	QUESTIONNAIRE_RISK_LEVELS,
	QUESTIONNAIRE_TEMPLATE_IDS,
} from "../contracts"
import {
	getQuestionnaireTemplate,
	tSprayQualifierQuestionnaireTemplate,
	withQuestionnairePresentation,
} from "../templates/questionnaire-templates"
import {
	buildAggregateHardEligibilityFailure,
	buildHardEligibilityAnswerSignature,
	buildHardEligibilityNoToAllAnswers,
	buildQuestionnaireAnswerSummaries,
	buildQuestionnaireAnswerValue,
	findFirstDisqualifyingQuestionnaireAnswer,
	formatQuestionnaireAnswerValue,
	getQuestionnaireAnswerDetails,
	getQuestionnaireAnswerDraft,
	getQuestionnaireQuestionsForPhase,
	getSelectedQuestionnaireAnswers,
	isQuestionnairePhaseComplete,
	isQuestionnaireQuestionAnswered,
	isQuestionnaireStructuredAnswer,
	questionnaireAnswerRequiresDetails,
} from "./questionnaire-evaluation"

export const questionnaire = {
	templateIds: QUESTIONNAIRE_TEMPLATE_IDS,
	defaultTemplateId: DEFAULT_QUESTIONNAIRE_TEMPLATE_ID,
	defaultTemplateVersion: DEFAULT_QUESTIONNAIRE_TEMPLATE_VERSION,
	questionTypes: QUESTIONNAIRE_QUESTION_TYPES,
	phases: QUESTIONNAIRE_PHASES,
	genders: QUESTIONNAIRE_GENDERS,
	riskLevels: QUESTIONNAIRE_RISK_LEVELS,
	tSprayQualifierTemplate: tSprayQualifierQuestionnaireTemplate,
	template: getQuestionnaireTemplate,
	withPresentation: withQuestionnairePresentation,
	questionsForPhase: getQuestionnaireQuestionsForPhase,
	answerDraft: getQuestionnaireAnswerDraft,
	answerDetails: getQuestionnaireAnswerDetails,
	selectedAnswers: getSelectedQuestionnaireAnswers,
	answerRequiresDetails: questionnaireAnswerRequiresDetails,
	answerValue: buildQuestionnaireAnswerValue,
	isQuestionAnswered: isQuestionnaireQuestionAnswered,
	isPhaseComplete: isQuestionnairePhaseComplete,
	isStructuredAnswer: isQuestionnaireStructuredAnswer,
	firstDisqualifyingAnswer: findFirstDisqualifyingQuestionnaireAnswer,
	answerSummaries: buildQuestionnaireAnswerSummaries,
	formatAnswerValue: formatQuestionnaireAnswerValue,
	hardEligibilityNoToAllAnswers: buildHardEligibilityNoToAllAnswers,
	hardEligibilityAnswerSignature: buildHardEligibilityAnswerSignature,
	aggregateHardEligibilityFailure: buildAggregateHardEligibilityFailure,
} as const
